import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  age: string;
  role: string;
  quote: string;
  rating: number;
}
export function TestimonialCard({
  name,
  age,
  role,
  quote,
  rating
}: TestimonialCardProps) {
  return <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-md" data-id="element-332">
      <div className="flex gap-1 mb-3" data-id="element-333">
        {Array.from({
        length: 5
      }).map((_, i) => <StarIcon key={i} className={`w-5 h-5 ${i < rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} aria-hidden="true" data-id="element-334" />)}
      </div>
      <blockquote className="text-gray-700 text-base leading-relaxed mb-4 italic" data-id="element-335">
        "{quote}"
      </blockquote>
      <div className="flex items-center gap-3" data-id="element-336">
        <div className="w-10 h-10 rounded-full bg-solution text-white flex items-center justify-center font-bold text-sm flex-shrink-0" data-id="element-337">
          {name.charAt(0)}
        </div>
        <div data-id="element-338">
          <p className="font-semibold text-gray-900 text-sm" data-id="element-339">
            {name}, {age}
          </p>
          <p className="text-gray-500 text-xs" data-id="element-340">{role}</p>
        </div>
      </div>
    </div>;
}